import Vue from 'vue';
import { createStore } from 'vuex'
import getters from './getters';
import user from './modules/user';

// Vue.use(Vuex);
export default createStore({
// const store = new Vuex.Store({
  modules: {
    user,
  },
  getters,
});

// export default store;
